import React from 'react';
import $ from "jquery";
import throttle from "lodash.throttle";
import { Loader } from '../../loader/index';
import './demandPlannerDifferences.styles.scss';

const headerValues = {
'1': 'Jan', '2': 'Feb', '3': 'Mar', '4': 'Apr', '5': 'May', '6': 'Jun', '7': 'Jul', '8': 'Aug', '9': 'Sep',
'10': 'Oct', '11': 'Nov', '12': 'Dec', 'Q1': 'Q1', 'Q2': 'Q2', 'Q3': 'Q3', 'Q4': 'Q4'
}

const DemandPlannerDifferences = ({
    data,
    isDemandPlannerDifferencesLoading,
    // fetchDemandPlannerDifferences,
    loadMoreData,
    isLoadingInitial
}) => {

    // useEffect(() => {
    //     fetchDemandPlannerDifferences();
    // },
    //     //eslint-disable-next-line
    //     []
    // )

    const load_more = throttle(loadMoreData, 800, {
        trailing: false,
    });

    const handleScroll = (e) => {
        var ignoreScrollEvents = false;
        function syncScroll(element1, element2) {
            element1.scroll(function (e) {
                var ignore = ignoreScrollEvents;
                ignoreScrollEvents = false;
                if (ignore) return;

                ignoreScrollEvents = true;
                element2.scrollTop(element1.scrollTop());
            });
        }
        syncScroll($("#div2"), $("#div1"));

        if (isDemandPlannerDifferencesLoading) return;
        let bottom = e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight < 50;
        if (bottom) {
            load_more()
        }
    };

    const calculateBrandTotal = (brands, monthNumber, key) => {
        let total = 0;
        if (brands.mskus?.length) {
            brands.mskus.forEach(msku => {
                if (msku.data?.length) {
                    msku.data.forEach(item => {
                        if (item.label === monthNumber) {
                            total = total + item[key];
                        }
                    })
                }
            })
        }

        return total?.toFixed(3);
    };

    if (isLoadingInitial) {
        return (
            <Loader flag={true} />
        )
    }
    else {
        return (
            <>
                <div className='dpd-cont df'>

                    <div id="div1" className='dpd-tables-cont' style={{ overflow: 'scroll hidden', width: '40%' }}>
                        {
                            data &&
                            data.general.map((item, ind) => {       // eslint-disable-line
                                if (ind === 0) {
                                    return (
                                        <table className='dpd-table' key={ind} style={{ width: '100%' }}>
                                            <thead>
                                                <tr>
                                                    {ind === 0 && <th className='dpd-table-cell' colSpan='3' style={{ backgroundColor: '#2a364f' }}></th>}
                                                </tr>
                                                <tr>
                                                    {ind === 0 && <th className='dpd-table-cell' colSpan='3' style={{ backgroundColor: '#023e7d', color: '#fff' }}>Description</th>}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    item.brands.map(brand => (
                                                        <>
                                                            {
                                                                brand.mskus.map((msku, mskuInd) => (
                                                                    <tr key={mskuInd} >
                                                                        {ind === 0 && <td className='dpd-table-cell'>{msku.code}</td>}
                                                                        {ind === 0 && <td className='dpd-table-cell' colSpan='2'>{msku.label}</td>}
                                                                    </tr>
                                                                ))
                                                            }
                                                            <tr>
                                                                {ind === 0 && <td className='dpd-table-cell' colSpan='3' style={{ backgroundColor: '#0353a4', color: '#fff' }}>{brand.label}</td>}
                                                            </tr>
                                                        </>
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                    )
                                }
                            })
                        }
                    </div>

                    <div id="div2" className='dpd-tables-cont df' style={{ width: '60%' }} onScroll={(e) => handleScroll(e)}>

                        {           //***** GENERAL DATA *****
                            data &&
                            data.general.map((item, ind) => (
                                <>
                                    <table className='dpd-table' key={ind}>
                                        <thead>
                                            <tr>
                                                <th colSpan={12} className='dpd-table-cell' style={{ backgroundColor: '#2a364f', color: '#fff' }}>{item.header}</th>
                                            </tr>
                                            {
                                                item.brands.map((brand, brandInd) => {      // eslint-disable-line
                                                    if (brandInd === 0) {
                                                        return (
                                                            <tr>
                                                                {
                                                                    brand.mskus[0].data.map((elm, elmInd) => (
                                                                        <td key={elmInd} className='dpd-table-cell' style={{ backgroundColor: '#023e7d', color: '#fff' }}>{headerValues[elm.label]}</td>
                                                                    ))
                                                                }
                                                            </tr>
                                                        )
                                                    }
                                                })
                                            }
                                        </thead>
                                        <tbody>
                                            {
                                                item.brands.map(brand => (
                                                    <>
                                                        {
                                                            brand.mskus.map((msku, mskuInd) => (
                                                                <tr key={mskuInd}>
                                                                    {
                                                                        msku.data.map(msku_month => (
                                                                            <td className='dpd-table-cell'>{msku_month.Value?.toFixed(3)}</td>
                                                                        ))
                                                                    }
                                                                </tr>
                                                            ))
                                                        }
                                                        <tr>
                                                            {
                                                                brand.mskus[0].data.map((msku_month, monthInd) => (
                                                                    <td key={monthInd} className='dpd-table-cell' style={{ backgroundColor: '#0353a4', color: '#fff' }}>{calculateBrandTotal(brand, msku_month.label, 'Value')}</td>
                                                                ))
                                                            }
                                                        </tr>
                                                    </>
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                    <div style={{ border: '1px solid', position:'sticky', top: 0 }}></div>
                                </>
                            ))
                        }

                        {           //***** DEMAND DRIVER DATA (AgreedBaselineForecast) *****
                            data &&
                            data.demand_drivers.map((item, ind) => (
                                <>
                                    <table className='dpd-table' key={ind}>
                                        <thead>
                                            <tr>
                                                <th colSpan={12} className='dpd-table-cell' style={{ backgroundColor: '#2a364f', color: '#fff' }}>{item.header} (AgreedBaselineForecast)</th>
                                            </tr>
                                            {
                                                item.brands.map((brand, brandInd) => {      // eslint-disable-line
                                                    if (brandInd === 0) {
                                                        return (
                                                            <tr>
                                                                {
                                                                    brand.mskus[0].data.map((elm, elmInd) => (
                                                                        <td key={elmInd} className='dpd-table-cell' style={{ backgroundColor: '#023e7d', color: '#fff' }}>{headerValues[elm.label]}</td>
                                                                    ))
                                                                }
                                                            </tr>
                                                        )
                                                    }
                                                })
                                            }
                                        </thead>
                                        <tbody>
                                            {
                                                item.brands.map(brand => (
                                                    <>
                                                        {
                                                            brand.mskus.map((msku, mskuInd) => (
                                                                <tr key={mskuInd}>
                                                                    {
                                                                        msku.data.map(msku_month => (
                                                                            <td className='dpd-table-cell'>{msku_month.AgreedBaselineForecast?.toFixed(3)}</td>
                                                                        ))
                                                                    }
                                                                </tr>
                                                            ))
                                                        }
                                                        <tr>
                                                            {
                                                                brand.mskus[0].data.map((msku_month, monthInd) => (
                                                                    <td key={monthInd} className='dpd-table-cell' style={{ backgroundColor: '#0353a4', color: '#fff' }}>{calculateBrandTotal(brand, msku_month.label, 'AgreedBaselineForecast')}</td>
                                                                ))
                                                            }
                                                        </tr>
                                                    </>
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                    <div style={{ border: '1px solid', position:'sticky', top: 0 }}></div>
                                </>
                            ))
                        }

                        {           //***** DEMAND DRIVER DATA (CategoryPromotionCP) *****
                            data &&
                            data.demand_drivers.map((item, ind) => (
                                <>
                                    <table className='dpd-table' key={ind}>
                                        <thead>
                                            <tr>
                                                <th colSpan={12} className='dpd-table-cell' style={{ backgroundColor: '#2a364f', color: '#fff' }}>{item.header} (CategoryPromotionCP)</th>
                                            </tr>
                                            {
                                                item.brands.map((brand, brandInd) => {      // eslint-disable-line
                                                    if (brandInd === 0) {
                                                        return (
                                                            <tr>
                                                                {
                                                                    brand.mskus[0].data.map((elm, elmInd) => (
                                                                        <td key={elmInd} className='dpd-table-cell' style={{ backgroundColor: '#023e7d', color: '#fff' }}>{headerValues[elm.label]}</td>
                                                                    ))
                                                                }
                                                            </tr>
                                                        )
                                                    }
                                                })
                                            }
                                        </thead>
                                        <tbody>
                                            {
                                                item.brands.map(brand => (
                                                    <>
                                                        {
                                                            brand.mskus.map((msku, mskuInd) => (
                                                                <tr key={mskuInd}>
                                                                    {
                                                                        msku.data.map(msku_month => (
                                                                            <td className='dpd-table-cell'>{msku_month.CategoryPromotionCP?.toFixed(3)}</td>
                                                                        ))
                                                                    }
                                                                </tr>
                                                            ))
                                                        }
                                                        <tr>
                                                            {
                                                                brand.mskus[0].data.map((msku_month, monthInd) => (
                                                                    <td key={monthInd} className='dpd-table-cell' style={{ backgroundColor: '#0353a4', color: '#fff' }}>{calculateBrandTotal(brand, msku_month.label, 'CategoryPromotionCP')}</td>
                                                                ))
                                                            }
                                                        </tr>
                                                    </>
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                    <div style={{ border: '1px solid', position:'sticky', top: 0 }}></div>
                                </>
                            ))
                        }

                        {           //***** DEMAND DRIVER DATA (CustomerPromotionSBB) *****
                            data &&
                            data.demand_drivers.map((item, ind) => (
                                <>
                                    <table className='dpd-table' key={ind}>
                                        <thead>
                                            <tr>
                                                <th colSpan={12} className='dpd-table-cell' style={{ backgroundColor: '#2a364f', color: '#fff' }}>{item.header} (CustomerPromotionSBB)</th>
                                            </tr>
                                            {
                                                item.brands.map((brand, brandInd) => {      // eslint-disable-line
                                                    if (brandInd === 0) {
                                                        return (
                                                            <tr>
                                                                {
                                                                    brand.mskus[0].data.map((elm, elmInd) => (
                                                                        <td key={elmInd} className='dpd-table-cell' style={{ backgroundColor: '#023e7d', color: '#fff' }}>{headerValues[elm.label]}</td>
                                                                    ))
                                                                }
                                                            </tr>
                                                        )
                                                    }
                                                })
                                            }
                                        </thead>
                                        <tbody>
                                            {
                                                item.brands.map(brand => (
                                                    <>
                                                        {
                                                            brand.mskus.map((msku, mskuInd) => (
                                                                <tr key={mskuInd}>
                                                                    {
                                                                        msku.data.map(msku_month => (
                                                                            <td className='dpd-table-cell'>{msku_month.CustomerPromotionSBB?.toFixed(3)}</td>
                                                                        ))
                                                                    }
                                                                </tr>
                                                            ))
                                                        }
                                                        <tr>
                                                            {
                                                                brand.mskus[0].data.map((msku_month, monthInd) => (
                                                                    <td key={monthInd} className='dpd-table-cell' style={{ backgroundColor: '#0353a4', color: '#fff' }}>{calculateBrandTotal(brand, msku_month.label, 'CustomerPromotionSBB')}</td>
                                                                ))
                                                            }
                                                        </tr>
                                                    </>
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                    <div style={{ border: '1px solid', position:'sticky', top: 0 }}></div>
                                </>
                            ))
                        }

                        {           //***** DEMAND DRIVER DATA (CustomerPromotionTPR) *****
                            data &&
                            data.demand_drivers.map((item, ind) => (
                                <>
                                    <table className='dpd-table' key={ind}>
                                        <thead>
                                            <tr>
                                                <th colSpan={12} className='dpd-table-cell' style={{ backgroundColor: '#2a364f', color: '#fff' }}>{item.header} (CustomerPromotionTPR)</th>
                                            </tr>
                                            {
                                                item.brands.map((brand, brandInd) => {      // eslint-disable-line
                                                    if (brandInd === 0) {
                                                        return (
                                                            <tr>
                                                                {
                                                                    brand.mskus[0].data.map((elm, elmInd) => (
                                                                        <td key={elmInd} className='dpd-table-cell' style={{ backgroundColor: '#023e7d', color: '#fff' }}>{headerValues[elm.label]}</td>
                                                                    ))
                                                                }
                                                            </tr>
                                                        )
                                                    }
                                                })
                                            }
                                        </thead>
                                        <tbody>
                                            {
                                                item.brands.map(brand => (
                                                    <>
                                                        {
                                                            brand.mskus.map((msku, mskuInd) => (
                                                                <tr key={mskuInd}>
                                                                    {
                                                                        msku.data.map(msku_month => (
                                                                            <td className='dpd-table-cell'>{msku_month.CustomerPromotionTPR?.toFixed(3)}</td>
                                                                        ))
                                                                    }
                                                                </tr>
                                                            ))
                                                        }
                                                        <tr>
                                                            {
                                                                brand.mskus[0].data.map((msku_month, monthInd) => (
                                                                    <td key={monthInd} className='dpd-table-cell' style={{ backgroundColor: '#0353a4', color: '#fff' }}>{calculateBrandTotal(brand, msku_month.label, 'CustomerPromotionTPR')}</td>
                                                                ))
                                                            }
                                                        </tr>
                                                    </>
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                    <div style={{ border: '1px solid', position:'sticky', top: 0 }}></div>
                                </>
                            ))
                        }

                        {           //***** DEMAND DRIVER DATA (HolidaysDIP) *****
                            data &&
                            data.demand_drivers.map((item, ind) => (
                                <>
                                    <table className='dpd-table' key={ind}>
                                        <thead>
                                            <tr>
                                                <th colSpan={12} className='dpd-table-cell' style={{ backgroundColor: '#2a364f', color: '#fff' }}>{item.header} (HolidaysDIP)</th>
                                            </tr>
                                            {
                                                item.brands.map((brand, brandInd) => {      // eslint-disable-line
                                                    if (brandInd === 0) {
                                                        return (
                                                            <tr>
                                                                {
                                                                    brand.mskus[0].data.map((elm, elmInd) => (
                                                                        <td key={elmInd} className='dpd-table-cell' style={{ backgroundColor: '#023e7d', color: '#fff' }}>{headerValues[elm.label]}</td>
                                                                    ))
                                                                }
                                                            </tr>
                                                        )
                                                    }
                                                })
                                            }
                                        </thead>
                                        <tbody>
                                            {
                                                item.brands.map(brand => (
                                                    <>
                                                        {
                                                            brand.mskus.map((msku, mskuInd) => (
                                                                <tr key={mskuInd}>
                                                                    {
                                                                        msku.data.map(msku_month => (
                                                                            <td className='dpd-table-cell'>{msku_month.HolidaysDIP?.toFixed(3)}</td>
                                                                        ))
                                                                    }
                                                                </tr>
                                                            ))
                                                        }
                                                        <tr>
                                                            {
                                                                brand.mskus[0].data.map((msku_month, monthInd) => (
                                                                    <td key={monthInd} className='dpd-table-cell' style={{ backgroundColor: '#0353a4', color: '#fff' }}>{calculateBrandTotal(brand, msku_month.label, 'HolidaysDIP')}</td>
                                                                ))
                                                            }
                                                        </tr>
                                                    </>
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                    <div style={{ border: '1px solid', position:'sticky', top: 0 }}></div>
                                </>
                            ))
                        }
                    </div>
                </div>
                {
                    isDemandPlannerDifferencesLoading &&
                    <div>Loading...</div>
                }
            </>
        );
    }
}

export default DemandPlannerDifferences;